import React from 'react'
import {Table, TableBody, TableRow, TableCell} from '@material-ui/core'
import {WithContext as ReactTags} from 'react-tag-input'

class SynonymTable extends React.Component {
  handleAddition = newTag => {
    const {id, ...tags} = newTag
    const tag = Object.keys(tags)[0]
    const tagQuery = {
      [tag]: {
        changed: {
          $set: true,
        },
        synonyms: {
          $push: [tags[tag]],
        },
      },
    }
    const output = this.props.child
      ? {
          [this.props.name]: {
            child: tagQuery,
          },
        }
      : {
          [this.props.name]: tagQuery,
        }

    this.props.onNewTag(output)
  }

  handleDelete = tag => index => {
    const synonyms = this.props.data[tag].synonyms.filter((s, i) => i !== index)
    const tagQuery = {
      [tag]: {
        changed: {
          $set: true,
        },
        synonyms: {
          $set: synonyms,
        },
      },
    }
    const output = this.props.child
      ? {
          [this.props.name]: {
            child: tagQuery,
          },
        }
      : {
          [this.props.name]: tagQuery,
        }

    this.props.onNewTag(output)
  }

  render() {
    const {data} = this.props
    return (
      <Table>
        <TableBody>
          {Object.keys(data).map(wordRow => (
            <TableRow key={wordRow}>
              <TableCell style={{width: '25%', paddingRight: 20}}>
                {wordRow}
              </TableCell>
              <TableCell>
                <ReactTags
                  allowDragDrop={false}
                  autofocus={false}
                  handleDelete={this.handleDelete(wordRow)}
                  handleAddition={this.handleAddition}
                  labelField={wordRow}
                  tags={data[wordRow].synonyms.map(synonym => ({
                    id: synonym,
                    [wordRow]: synonym,
                  }))}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }
}

SynonymTable.defaultProps = {
  child: false,
}

export default SynonymTable



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/SynonymTable.js